;(function($, userPersonalisation, trackEvents){
    'use strict';

    var rnn = window.rnn;

    function checkWeatherName(todaysForecast) {
        if (['clearing_shower', 'showers_easing', 'showers_increasing', 'possible_shower', 'rain', 'showers', 'heavy_rain']
            .indexOf(todaysForecast.weatherName) !== -1) {
                todaysForecast.weatherName = 'drizzle';
        } else if (['possible_thunderstorm', 'thunderstorm', 'thunderstorms']
            .indexOf(todaysForecast.weatherName) !== -1) {
                todaysForecast.weatherName = 'possible_thunderstorm';
        } else if (['drizzle_clearing']
            .indexOf(todaysForecast.weatherName) !== -1) {
                todaysForecast.weatherName = 'rain_developing';
        } else if (['rain_tending_to_snow', 'snow_showers', 'rain_and_snow']
            .indexOf(todaysForecast.weatherName) !== -1) {
                todaysForecast.weatherName = 'snow_tending_to_rain';
        } else if (['wind_and_showers_easing', 'windy_with_showers']
            .indexOf(todaysForecast.weatherName) !== -1) {
                todaysForecast.weatherName = 'windy_with_rain';
        } else if (['late_shower']
            .indexOf(todaysForecast.weatherName) !== -1) {
                todaysForecast.weatherName = 'late_showers';
        }

        var theURL = rnn.site.mediaURL + 'rnn/base/img/weather/60x60/' + todaysForecast.weatherName + '_white.png';
        return theURL;
    }

    function updateWidget(weatherWidget, $listItem) {
        var cookieName = weatherWidget.data('weather').cookieName;
        var todaysForecast = weatherWidget.find('.localities option:selected').data('forecast') || $listItem.data('forecast');

        if (weatherWidget.hasClass('weatherModuleHat')) {
            var theURL = checkWeatherName(todaysForecast);
            var imgExists = $('.weatherModuleHat .left-col .temp').length;

            if (!imgExists) {
                // build and insert image
                var imgHTML = '<img class="temp" src="' + theURL + '" />';
                $(imgHTML).insertBefore('.weatherModuleHat .left-col .weather-detail');
            } else {
                // replace the existing image
                weatherWidget.find('.left-col img.temp').attr('src', theURL);
            }

            weatherWidget.find('.detail-temp').html(todaysForecast.tempMin + '-' + todaysForecast.tempMax + '&deg;C');
            weatherWidget.find('.desc-temp').html(todaysForecast.weatherDesc);
            weatherWidget.find('.region-name').html(todaysForecast.locality);
            weatherWidget.find('.left-col a').attr('href', todaysForecast.weatherUrl);
        } else {
            weatherWidget.find('.weatherImage').attr('src', todaysForecast.imgSrc).attr('title', todaysForecast.imgTitle);
            weatherWidget.find('.temp.max .tempVal').html(todaysForecast.tempMax + '&deg;C');
            weatherWidget.find('.temp.min .tempVal').html(todaysForecast.tempMin + '&deg;C');
        }

        Cookies.set(cookieName, todaysForecast.locality, { expires: 365, path: '/' });
    }

    function updateWeather(weatherModule) {
        var cookieName = weatherModule.data('weather').cookieName;
        var todaysForecast = weatherModule.find('.localities option:selected').data('forecast');

        weatherModule.find('i').attr('class', todaysForecast.weatherClass);
        weatherModule.find('.content a').attr('title', todaysForecast.weatherDesc).attr('href', todaysForecast.weatherUrl);
        weatherModule.find('.large-temp').html(todaysForecast.tempMax + '&deg;C');
        weatherModule.find('.desc-temp').html(todaysForecast.weatherDesc);
        weatherModule.find('.detail-temp').html(todaysForecast.tempMin + '-' + todaysForecast.tempMax + '&deg;C');

        // Update more link
        weatherModule.find('.more-link').attr('href', todaysForecast.weatherUrl);

        Cookies.set(cookieName, todaysForecast.locality, { expires: 365, path: '/' });
    }


    function updateWeatherContainer(weatherContainer, forecastData) {
        var forecast = forecastData.forecast;
        var currentDay;
        var currentClassPrefix = 'weather-*';
        var currentLocality = forecast['day-1'][0].locality;
        var counter = $('.weatherContainer .weather-widget-item .span2').length;
        var buttonLabel = $('.weatherContainer .weather-controls .btn-group .currentLabel');

        buttonLabel.html(currentLocality);

        for (var i=1; i <= counter; i++) {
            var $widget_item = $('.weatherContainer .outlook-' + i);

            currentDay = forecast['day-' + i][0];

            $widget_item.find('.span2 .forecastDate').alterClass(currentClassPrefix, currentDay.weatherClass); // icon change
            $widget_item.find('.span2 .temperatures .max .tempVal').html(currentDay.maxTemp + '&deg;C');  // max temp
            $widget_item.find('.span2 .temperatures .min .tempVal').html(currentDay.minTemp + '&deg;C');  // min temp
            $widget_item.find('.span2 .desc').html(currentDay.desc);  // desc
            $widget_item.find('.span2 .precip').html(currentDay.precipChance + '% chance of rain');  // precip
        }
    }


    function eventTrackingLatestBar() {
        var latest_bar_column = $('.latest-bar-column');
        var len = $('.latest-bar-column').length;
        var index = 0;
        var i = 0;
        var aElement = latest_bar_column.find('a');

        aElement.on('click', function() {
            var parent = $(this).parents('.latest-bar-column').addClass('selected');

            for (index; index < len; index++) {
                if ($(latest_bar_column[index]).hasClass('selected')) {
                    i = index;
                    break;
                }
            }

            if (parent) {
                parent.removeClass('selected');
                var container_category = parent.data('container-slug') || '';
                trackEvents.track_event(container_category, 'click', 'Position', (i + 1));
            }
        });
    }

    // Initialise Bootstrap plugins
    function initWeather() {
        var $weatherModuleHat = $('.weatherModuleHat');
        var $hatWeatherToggle = $weatherModuleHat.find('.dropdown-toggle');
        var $hatWeatherMenu = $weatherModuleHat.find('.dropdown-menu');

        eventTrackingLatestBar();

        $(document).on('change', '.weatherWidget .localities', function() {
            updateWidget($(this).closest('.weatherWidget'), null);
        });

        $(document).on('change', '.weatherModuleHat .localities', function() {
            updateWidget($(this).closest('.weatherModuleHat'));
        });

        // Latest bar
        $(document).on('change', '.weatherModule .localities', function() {
            updateWeather($(this).closest('.weatherModule'));
        });

        $hatWeatherToggle.click(function() {
             $hatWeatherMenu.slideToggle();
        });

        $hatWeatherMenu.find('li').click(function() {
            updateWidget($weatherModuleHat, $(this));
            $hatWeatherMenu.slideUp();
        });

        // For the 4-item container
        $('#weatherForecast .weather-controls .localities li').click(function() {
            var $data = $(this).data();
            updateWeatherContainer($('.weatherContainer'), $data);
        });

        $('.weatherModule').each(function() {
            var weatherModule = $(this);
            var cookieName = weatherModule.data('weather').cookieName;
            var localities = weatherModule.find('.localities');

            if (Cookies.get(cookieName)) {
                localities
                .find('[value=\'' + Cookies.get(cookieName) + '\']')
                .attr('selected', 'selected');
                localities.trigger('change');
            }
        });

        $('.weatherWidget, .weatherModuleHat').each(function() {
            var weatherWidget = $(this);
            var cookieName = weatherWidget.data('weather').cookieName;
            var localities = weatherWidget.find('.localities');

            if (Cookies.get(cookieName)) {
                localities.find('[value=\'' + Cookies.get(cookieName) + '\']').attr('selected', 'selected');
                localities.trigger('change');

                weatherWidget.find('.dropdown-menu li').each(function() {
                    if (Cookies.get(cookieName) === $(this).data('forecast').locality) {
                        updateWidget(weatherWidget, $(this));
                    }
                });
            } else {
                // there is no cookie set, meaning we need to build the image for the first time in
                // top hat weather widget.
                weatherWidget.find('.dropdown-menu li').each(function() {
                    if (weatherWidget.data('locality') === $(this).data('forecast').locality) {
                        updateWidget(weatherWidget, $(this));
                    }
                });
            }
        });
    }

    rnn.modules.register('weather', {
        init: initWeather
    });

})(jQuery, window.rnn.modules.userPersonalisation, window.rnn.modules.trackEvents);
